import { render, staticRenderFns } from "./specialPapers.vue?vue&type=template&id=6a1ec903&scoped=true&"
import script from "./specialPapers.vue?vue&type=script&lang=js&"
export * from "./specialPapers.vue?vue&type=script&lang=js&"
import style0 from "./specialPapers.vue?vue&type=style&index=0&id=6a1ec903&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ec903",
  null
  
)

export default component.exports